import { Box, Typography } from "@mui/material";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const AppHistoryView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      {(entityData?.okta_data?.creation_date ||
        entityData?.salesforce_data?.creation_date ||
        entityData?.google_data?.creation_date) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2">Creation Date</Typography>
          </Box>
          <Box display={"flex"} gap={1} flexDirection={"column"} ml={3}>
            {entityData?.okta_data?.creation_date && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"okta"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.okta_data?.creation_date}
              />
            )}
            {entityData?.salesforce_data?.creation_date && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"salesforce"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData.salesforce_data.creation_date}
              />
            )}
            {entityData?.google_data?.creation_date && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"google"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.google_data?.creation_date}
              />
            )}
          </Box>
        </Box>
      )}
      {(entityData?.okta_data?.last_updated ||
        entityData?.salesforce_data?.last_updated ||
        entityData?.google_data?.last_updated_date) && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2">Last Updated Time</Typography>
          </Box>
          <Box display={"flex"} gap={1} flexDirection={"column"} ml={3}>
            {entityData?.okta_data?.last_updated && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"okta"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.okta_data?.last_updated}
              />
            )}
            {entityData?.salesforce_data?.last_updated && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"salesforce"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData.salesforce_data.last_updated}
              />
            )}
            {entityData?.google_data?.last_updated_date && (
              <TextIntegrationStyle
                title={
                  <Box display={"flex"} gap={1}>
                    <IntegrationImage
                      name={"google"}
                      width={"16px"}
                      newLogo={true}
                    />
                  </Box>
                }
                value={entityData?.google_data?.last_updated_date}
              />
            )}
          </Box>
        </Box>
      )}
      {entityData?.zoom_data?.approved_time && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant="subtitle2">Approved Time</Typography>
          </Box>
          <Box display={"flex"} gap={1} flexDirection={"column"} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"} gap={1}>
                  <IntegrationImage
                    name={"zoom"}
                    width={"16px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.zoom_data?.approved_time}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AppHistoryView;
